import { render, staticRenderFns } from "./LineBreakBehaviorEditor.vue?vue&type=template&id=5e767c05&"
import script from "./LineBreakBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./LineBreakBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports